"use client";

import { useSearchParams } from "next/navigation";
import BreadCrumb from "@/app/components/lib/breadcrumb/BreadCrumb";
import { PagesPaths } from "@/utils/functions/pages-paths";
import { IBlogsCategories } from "@/api/AppApi/services/blogs/interfaces/IBlogs";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  blogDetails: IBlogsCategories;
}

const BlogBreadCrumb: React.FC<Props> = ({ blogDetails }) => {
  const searchParams = useSearchParams();
  const t = useTranslation();
  const KWC = process.env.NEXT_PUBLIC_COUNTRY === "KWT";
  
  const baseTitle = t[KWC ? "news" : "blog"] || (KWC ? "News" : "Blog");
  
  let currentTitle: string | undefined;
  
  const categoryParam = searchParams?.get("category");
  const dateParam = searchParams?.get("date");
  const tagsParam = searchParams?.get("tags");

  if (categoryParam) {
    currentTitle = blogDetails.categories.find(c => c.key === categoryParam)?.value;
  } else if (dateParam) {
    currentTitle = blogDetails.archives.find(a => a.key === dateParam)?.value;
  } else if (tagsParam) {
    const tagsArray = tagsParam.split(",").filter(Boolean);
    if (tagsArray.length === 1) {
      currentTitle = blogDetails.tags.find(tag => tag.key === tagsArray[0])?.value;
    } else if (tagsArray.length > 1) {
      currentTitle = undefined; 
    }
  } else if (searchParams?.get("authors")) {
    currentTitle = t.authors || "Authors";
  }

  const finalTitle = currentTitle 
    ? `${baseTitle} - ${currentTitle}`
    : baseTitle;

  return (
    <BreadCrumb
      hierarchy={[
        {
          text: baseTitle,
          link: PagesPaths.blog,
        },
        { text: finalTitle },
      ]}
    />
  );
};

export default BlogBreadCrumb;
